import { ReactNode, HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  hover?: boolean;
}

export function Card({ children, hover, className = "", ...props }: CardProps) {
  const base = "panel";
  const h = hover ? " panel-hover" : "";
  return (
    <div className={`${base}${h} ${className}`} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div data-panel-toolbar className={`flex min-w-0 flex-wrap items-center justify-between gap-3 px-4 py-5 sm:px-5 ${className}`}>{children}</div>;
}

export function CardBody({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div data-panel-content className={`min-w-0 px-4 py-5 sm:px-5 ${className}`}>{children}</div>;
}

export function CardFooter({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`flex items-center justify-between px-5 py-4 border-t border-border ${className}`}>{children}</div>;
}
